export const getSetupBy = (email: string, name: string | undefined) => {
  return name ? `${name} (${email})` : email
}
